import { Toaster as Sonner } from 'sonner'
import { useTheme } from '../lib/theme'

export { toast } from 'sonner'

export function Toaster() {
  const { resolved } = useTheme()

  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'rounded-xl! border! border-border! bg-surface! text-foreground! shadow-elevated! font-sans! text-sm!',
          description: 'text-muted-foreground!',
        },
      }}
    />
  )
}
